/**
 * Checks if the character is an A (arc-to) path command.
 */
export function isArcCommand(code) {
    return (code | 0x20) === 0x61;
}
//# sourceMappingURL=is-arc-command.js.map